// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__1yaCQ","header":"ClearentDisclaimer_header__-L_NO","inner":"ClearentDisclaimer_inner__1SJ7f"};